import { createContext, useContext } from "react";
import { QuestionCheckResult } from "../../types/syncCheckResult";

export const questionCheckResultContext = createContext<QuestionCheckResult | null>(null);

export function useQuestionCheckResultContext() {
  const context = useContext(questionCheckResultContext);
  if (!context) {
    throw new Error("useQuestionCheckResultContext must be used within a QuestionCheckResultProvider");
  }
  return context;
}